import React, { useRef } from "react";

export default function TimePickerButton({
  value,
  onChange,
  icon,
  displayValue,
}) {
  const inputRef = useRef(null);

  const openPicker = () => {
    const el = inputRef.current;
    if (!el) return;

    try {
      if (typeof el.showPicker === "function") {
        el.showPicker();
        return;
      }
    } catch {}

    try {
      el.focus();
      el.click();
    } catch {}
  };

  return (
    <div className="relative h-[52px] w-full min-w-0 overflow-hidden rounded-[18px] sm:h-11 sm:rounded-xl">
      <button
        type="button"
        onClick={openPicker}
        className="relative flex h-full w-full items-center justify-center rounded-[18px] border border-gray-300 bg-white px-4 pr-12 text-center text-[16px] font-medium leading-none text-gray-900 outline-none transition hover:bg-gray-50 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-[#0F172A] dark:text-white dark:hover:bg-[#111827] sm:rounded-xl sm:px-3 sm:pr-10 sm:text-sm"
      >
        <span className="flex h-full min-w-0 items-center justify-center truncate leading-none">
          {displayValue || value || "--:--"}
        </span>

        <span className="pointer-events-none absolute right-4 top-1/2 flex -translate-y-1/2 items-center justify-center text-gray-500 dark:text-gray-400 sm:right-3">
          {icon}
        </span>
      </button>

      <input
        ref={inputRef}
        type="time"
        step="60"
        value={value || ""}
        onChange={onChange}
        onClick={openPicker}
        className="absolute inset-0 z-20 h-full w-full cursor-pointer opacity-0"
        aria-label="시간 선택"
      />
    </div>
  );
}